import type { ColoredDotProps } from '../dot.component';
import { Dot } from '../dot.component';

export const SuccessDot = ({ children, ...props }: ColoredDotProps) => (
  <Dot color='success' {...props}>
    <>{children}</>
  </Dot>
);
